import React, { useReducer } from 'react'
import ManifestContext from './manifestContext'
import ManifestReducer from './manifestReducer'
import { apiCall } from '../../common/api'
import { response } from '../common'

import {
    GET_ALL_MANIFEST_PRODUCTS,
    GET_SINGLE_MANIFEST,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
} from './manifestTypes'

const ManifestState = (props) => {
    const initialState = {
        all_manifest_products: {
            records: [],
            totalRecords: 0,
            setDisp: '',
        },
        single_manifest: {
            record: {},
            from: '',
        },
    }

    const [state, dispatch] = useReducer(ManifestReducer, initialState)
    let resp = new response(dispatch, RESPONSE_STATUS)

    const getAllManifestProducts = async (formData, from) => {
        try {
            const [res] = await Promise.all([
                apiCall('post', 'manifests', formData, '', 'manifest'),
            ])
            from = from ? from : 'Communicationtemplates'
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_ALL_MANIFEST_PRODUCTS,
                    payload: {
                        records: res.data.data.responseData.records.length
                            ? res.data.data.responseData.records
                            : [],
                        totalRecords: res.data.data.responseData.totalRecords,
                        setDisp: res.data.data.responseData.setDisp,
                        from: from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const getSingleManifest = async (formData, fromVariable) => {
        try {
            const from = 'getSingleManifest'
            const [res] = await Promise.all([
                apiCall('post', 'getSingleManifest', formData, '', 'manifest'),
            ])
            if (res.data.status === 'success') {
                dispatch({
                    type: GET_SINGLE_MANIFEST,
                    payload: {
                        record: res.data.data.responseData.record
                            ? res.data.data.responseData.record
                            : {},
                        from: fromVariable ? fromVariable : from,
                    },
                })
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const changeProductStatus = async (formData, from) => {
        try {
            //const from = 'productchange'
            from = from ? from : 'productchange'
            const [res] = await Promise.all([
                apiCall('post', 'changeStatus', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const projectAction = async (formData) => {
        try {
            const from = 'projectAction'
            const [res] = await Promise.all([
                apiCall('post', 'projectAction', formData, '', 'product'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const uploadXLSXFile = async (formData) => {
        const from = 'uploadManifest'
        try {
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'manifest'),
            ])
            resp.commonResponse(res.data, from)
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const sampleXLSXFile = async (formData) => {
        try {
            const from = 'sampleManifest'
            const [res] = await Promise.all([
                apiCall('post', from, formData, '', 'manifest'),
            ])
            if (res.data.status === 'success') {
                setTimeout(() => {
                    window.open(res.data.data.responseData.filename)
                }, 800)
            } else if (res.data.status === 'error') {
                resp.commonResponse(res.data, from)
            } else {
                resp.commonErrorResponse(from)
            }
        } catch (err) {
            dispatch({
                type: RESPONSE_STATUS,
                payload: 'Something went wrong!',
            })
        }
    }

    const clearResponse = () =>
        dispatch({
            type: CLEAR_RESPONSE,
        })

    return (
        <ManifestContext.Provider
            value={{
                // buyer_allproducts: state.buyer_allproducts,
                all_manifest_products: state.all_manifest_products,
                single_manifest: state.single_manifest,
                responseStatus: state.responseStatus,
                clearResponse,
                getAllManifestProducts,
                getSingleManifest,
                changeProductStatus,
                projectAction,
                uploadXLSXFile,
                sampleXLSXFile,
            }}
        >
            {props.children}
        </ManifestContext.Provider>
    )
}

export default ManifestState
